import React from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import JobDetailsMain from "../../components/job-details/JobDetailsMain";
import Footer from "../../components/common/Footer";
import { RODEO_PAGE_NAME } from "../../_config";

const JobDetailsPage = (props: Record<string, any>) => (
  <>
    <Header variant="topbar" />
    <Sidebar page={RODEO_PAGE_NAME.JOB_DETAILS} />
    <JobDetailsMain />
    <Footer variant="dashboard" />
  </>
);

export default JobDetailsPage;
